// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1lRVG","content":"styles_content__1nknK","selectAll":"styles_selectAll__2Z27d"};